import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

// tslint:disable-next-line:no-duplicate-imports
// @ts-ignore
import _moment from 'moment';

import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { TranslateService } from '@ngx-translate/core';
// tslint:disable-next-line:no-duplicate-imports
// @ts-ignore
import { default as _rollupMoment } from 'moment';
import { MappingComponent } from 'src/app/mapping/mapping.component';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';


const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'L',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY-MM-DD',
    dateA11yLabel: 'L',
    monthYearA11yLabel: 'YYYY-MM-DD',
  },
};

@Component({
    selector: 'app-overlay-all-dialog',
    templateUrl: './overlay-all-dialog.component.html',
    styleUrls: ['./overlay-all-dialog.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class OverlayAllDialogComponent implements OnInit {

  date;
  public varRequired;
  public varLength;
  public varDate;
  public validation_messages;

  overlayAllForm = new FormGroup({
    variance: new FormControl(1, Validators.compose([
      Validators.required,
      Validators.minLength(1)
    ])),
    date: new FormControl(moment(), Validators.compose([
      Validators.required
    ]))
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<MappingComponent>,
    public translate: TranslateService
  ) { 
    this.validation_messages = {
      'variance': [
        { type: 'required', message: translate.instant('OVERLAY-ALL-DIALOG.ERROR-REQUIRED') },
        { type: 'minlength', message: translate.instant('OVERLAY-ALL-DIALOG.ERROR-LENGTH') }
      ],
      'date': [
        { type: 'required', message: translate.instant('OVERLAY-ALL-DIALOG.ERROR-DATE') }
      ]
    }

    if (this.data.date != null) {
      this.overlayAllForm.setValue({ variance: 1, date: this.data.date });
      this.date = moment(this.data.date);
    }
  }

  ngOnInit(): void {

  }

  dateChanged(event: MatDatepickerInputEvent<Date>) {
    this.date = event.value;
  }

  onSubmit() {
    let variance = this.overlayAllForm.controls.variance.value;

    let overlay = {
      "date": this.date.format("YYYY-MM-DD"),
      "variance": variance
    };

    this.dialogRef.close({ "overlay": overlay });
  }

}
